import * as base from "./base";
import * as derived from "./derived";

/**
 * Property selectors namespace
 *
 * Usage:
 * - properties.all(state) - Get all document properties
 * - properties.byUid('uid')(state) - Get property by UID
 * - properties.byName('name')(state) - Get property by name
 * - properties.datasheet(state) - Get datasheet property
 * - properties.manufacturerPartNumber(state) - Get MPN property
 */
export const properties = {
    ...base,
    ...derived,
} as const;

export type PropertiesSelectors = typeof properties;
